export default () => import(/* webpackChunkName: 'coffee/app/blockchain/order-chain' */ './OrderChain');
